import { useVirtualizer } from '@tanstack/react-virtual';
import { useRef } from 'react';
import {
  ListItem,
  ListItemButton,
  Checkbox,
  ListItemText,
} from '@mui/material';

type Polygon = {
  id: number;
  name: string;
  country?: string;
};

type Props = {
  polygons: Polygon[];
  selectedPolygonIds: Set<number>;
  onToggle: (id: number) => void;
  height?: number;
};

export default function VirtualizedPolygonList({
  polygons,
  selectedPolygonIds,
  onToggle,
  height = 500,
}: Props) {
  const parentRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: polygons.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 56, // MUI ListItem height
    overscan: 5,
  });

  return (
    <div
      ref={parentRef}
      style={{
        height,
        overflow: 'auto',
      }}
    >
      <div
        style={{
          height: rowVirtualizer.getTotalSize(),
          width: '100%',
          position: 'relative',
        }}
      >
        {rowVirtualizer.getVirtualItems().map(virtualRow => {
          const polygon = polygons[virtualRow.index];

          return (
            <ListItem
              key={polygon.id}
              disablePadding
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              <ListItemButton onClick={() => onToggle(polygon.id)}>
                <Checkbox
                  checked={selectedPolygonIds.has(polygon.id)}
                  edge="start"
                  disableRipple
                />
                <ListItemText
                  primary={polygon.name}
                  secondary={polygon.country || 'N/A'}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </div>
    </div>
  );
}
